webpackJsonp([18116671869107],{

/***/ 94:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 62:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(94);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NewsListing = function NewsListing(props) {
	  var data = props.data;
	
	  return _react2.default.createElement(
	    'section',
	    { className: 'features', id: 'features' },
	    _react2.default.createElement(
	      'div',
	      { className: 'container' },
	      _react2.default.createElement(
	        'div',
	        { className: 'row' },
	        _react2.default.createElement(
	          'div',
	          { className: 'col-12' },
	          _react2.default.createElement(
	            'h4',
	            { className: 'features-title' },
	            'Features'
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'row' },
	        _react2.default.createElement(
	          'div',
	          { className: 'col-12' },
	          _react2.default.createElement(
	            'ul',
	            { className: 'features-list' },
	            data.map(function (item, i) {
	              return _react2.default.createElement(
	                'li',
	                { className: 'features-list-item', key: i },
	                item.title
	              );
	            })
	          )
	        )
	      )
	    )
	  );
	};
	
	exports.default = NewsListing;
	module.exports = exports['default'];

/***/ }),

/***/ 95:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 63:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(95);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NewsListing = function NewsListing(props) {
	  return _react2.default.createElement(
	    'section',
	    { className: 'howto', id: 'howto' },
	    _react2.default.createElement(
	      'div',
	      { className: 'container' },
	      _react2.default.createElement(
	        'div',
	        { className: 'row' },
	        _react2.default.createElement(
	          'div',
	          { className: 'col-12' },
	          _react2.default.createElement(
	            'h4',
	            { className: 'howto-title' },
	            'How to'
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'row' },
	        _react2.default.createElement(
	          'div',
	          { className: 'col-12' },
	          _react2.default.createElement(
	            'ol',
	            { className: 'howto-list' },
	            props.data.map(function (item, i) {
	              return _react2.default.createElement(
	                'li',
	                { className: 'howto-list-item', key: i },
	                item.title
	              );
	            })
	          )
	        )
	      )
	    )
	  );
	};
	
	exports.default = NewsListing;
	module.exports = exports['default'];

/***/ }),

/***/ 334:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 161:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _aos = __webpack_require__(3);
	
	var _aos2 = _interopRequireDefault(_aos);
	
	var _reactHelmet = __webpack_require__(9);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _gatsbyLink = __webpack_require__(4);
	
	var _features = __webpack_require__(62);
	
	var _features2 = _interopRequireDefault(_features);
	
	var _howTo = __webpack_require__(63);
	
	var _howTo2 = _interopRequireDefault(_howTo);
	
	__webpack_require__(334);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* global graphql */
	
	var PricingPage = function (_React$Component) {
	  _inherits(PricingPage, _React$Component);
	
	  function PricingPage(props) {
	    _classCallCheck(this, PricingPage);
	
	    return _possibleConstructorReturn(this, _React$Component.call(this, props));
	  }
	
	  //==============
	  // React Methods
	  //==============
	
	  PricingPage.prototype.componentDidMount = function componentDidMount() {
	    var isBrowser = typeof window !== 'undefined';
	    var AOS = isBrowser ? __webpack_require__(3) : undefined;
	    this.aos = AOS;
	    this.aos.init();
	  };
	
	  PricingPage.prototype.componentDidUpdate = function componentDidUpdate() {
	    this.aos.refresh();
	  };
	
	  //==============
	  // Click Events
	  //==============
	
	  PricingPage.prototype.loadArticle = function loadArticle() {
	    console.log('loaded article');
	    window.open('https://medium.com/@GetFirstStep/getting-students-ahead-of-the-game-a7a5b987de8a');
	  };
	
	  //=================
	  // Render Component
	  //=================
	
	  PricingPage.prototype.render = function render() {
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        _reactHelmet2.default,
	        null,
	        _react2.default.createElement(
	          'title',
	          null,
	          'Pricing | The investment account of the future'
	        ),
	        _react2.default.createElement('meta', { name: 'description', content: 'Save with confidence, not high fees. No brokerage. No upfront fees. Cancel anytime' })
	      ),
	      _react2.default.createElement(
	        'section',
	        { className: 'simple-pricing', 'data-aos': 'fade-up', 'data-aos-once': true },
	        _react2.default.createElement(
	          'div',
	          { className: 'wrapper' },
	          _react2.default.createElement(
	            'div',
	            { className: 'inner-wrapper' },
	            _react2.default.createElement(
	              'div',
	              { className: 'title' },
	              _react2.default.createElement(
	                'h1',
	                null,
	                'Simple pricing that works for everyone'
	              ),
	              _react2.default.createElement(
	                'p',
	                null,
	                'Save with confidence, not high fees.',
	                _react2.default.createElement('br', null),
	                ' No brokerage. No  upfront fees. Cancel anytime'
	              )
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'section',
	        { className: 'pricing-switch', 'data-aos': 'fade-up', 'data-aos-once': true },
	        _react2.default.createElement(
	          'div',
	          { className: 'wrapper' },
	          _react2.default.createElement(
	            'div',
	            { className: 'inner-wrapper' },
	            _react2.default.createElement(
	              'div',
	              { className: 'row align-items-center justify-content-center' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-12 col-sm-5' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'price-thumb' },
	                  _react2.default.createElement(
	                    'h2',
	                    null,
	                    '$1.25',
	                    _react2.default.createElement(
	                      'span',
	                      null,
	                      'per month'
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'p',
	                    null,
	                    'for accounts under $5,500'
	                  ),
	                  _react2.default.createElement(
	                    'span',
	                    { className: 'note' },
	                    '$1.95 per month for Direct Debit'
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'col-12 col-sm-1 text-center' },
	                _react2.default.createElement(
	                  'span',
	                  { className: 'option-text' },
	                  'or'
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'col-12 col-sm-5' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'price-thumb' },
	                  _react2.default.createElement(
	                    'h2',
	                    null,
	                    '0.275%',
	                    _react2.default.createElement(
	                      'span',
	                      null,
	                      'a year'
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'p',
	                    null,
	                    'for accounts over $5,500'
	                  )
	                )
	              )
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'section',
	        { className: 'what-get', 'data-aos': 'fade-up', 'data-aos-once': true },
	        _react2.default.createElement(
	          'div',
	          { className: 'wrapper' },
	          _react2.default.createElement(
	            'div',
	            { className: 'inner-wrapper' },
	            _react2.default.createElement(
	              'h2',
	              { className: 'text-center' },
	              'What you get from us'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'row' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-md-6' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'item' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'check' },
	                    _react2.default.createElement('img', { src: (0, _gatsbyLink.withPrefix)('/images/icons/icon-tick.svg'), alt: 'Feature icon' })
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'info' },
	                    _react2.default.createElement(
	                      'h4',
	                      null,
	                      'Low minimums'
	                    ),
	                    _react2.default.createElement(
	                      'p',
	                      null,
	                      'Get started with as little as $1.'
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'col-md-6' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'item' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'check' },
	                    _react2.default.createElement('img', { src: (0, _gatsbyLink.withPrefix)('/images/icons/icon-tick.svg'), alt: 'Feature icon' })
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'info' },
	                    _react2.default.createElement(
	                      'h4',
	                      null,
	                      'Bank grade security'
	                    ),
	                    _react2.default.createElement(
	                      'p',
	                      null,
	                      'All sensitive data is secured using 256-bit encryption.'
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'col-md-6' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'item' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'check' },
	                    _react2.default.createElement('img', { src: (0, _gatsbyLink.withPrefix)('/images/icons/icon-tick.svg'), alt: 'Feature icon' })
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'info' },
	                    _react2.default.createElement(
	                      'h4',
	                      null,
	                      'Save effortlessly'
	                    ),
	                    _react2.default.createElement(
	                      'p',
	                      null,
	                      'Automatically save for your goals.'
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'col-md-6' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'item' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'check' },
	                    _react2.default.createElement('img', { src: (0, _gatsbyLink.withPrefix)('/images/icons/icon-tick.svg'), alt: 'Feature icon' })
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'info' },
	                    _react2.default.createElement(
	                      'h4',
	                      null,
	                      'Investing themes'
	                    ),
	                    _react2.default.createElement(
	                      'p',
	                      null,
	                      'We offer ETFs that let you invest by theme in industries, causes, and strategies.'
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'col-md-6' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'item' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'check' },
	                    _react2.default.createElement('img', { src: (0, _gatsbyLink.withPrefix)('/images/icons/icon-tick.svg'), alt: 'Feature icon' })
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'info' },
	                    _react2.default.createElement(
	                      'h4',
	                      null,
	                      'Make investing automatic'
	                    ),
	                    _react2.default.createElement(
	                      'p',
	                      null,
	                      'Create a saving plan so you can make investing a habit over the long run.'
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'col-md-6' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'item' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'check' },
	                    _react2.default.createElement('img', { src: (0, _gatsbyLink.withPrefix)('/images/icons/icon-tick.svg'), alt: 'Feature icon' })
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'info' },
	                    _react2.default.createElement(
	                      'h4',
	                      null,
	                      'Learn as you go'
	                    ),
	                    _react2.default.createElement(
	                      'p',
	                      null,
	                      'Tips, guides and lessons to help you grow your savings with confidence.'
	                    )
	                  )
	                )
	              )
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'container' },
	        _react2.default.createElement(
	          'section',
	          { className: 'content-block text-center special-offer', 'data-aos': 'fade-up', 'data-aos-once': true },
	          _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col-12' },
	              _react2.default.createElement(
	                'h2',
	                null,
	                'Students + FirstStep = \uD83D\uDE0D'
	              ),
	              _react2.default.createElement(
	                'p',
	                null,
	                'Students, you may not have a lot to save right now, but what you have is time - your greatest asset. With time you can make use of compound interest - essentially, interest on interest.'
	              ),
	              _react2.default.createElement(
	                'p',
	                null,
	                'Sign up with your student email and recieve the first 3 months free!'
	              ),
	              _react2.default.createElement(
	                'button',
	                { onClick: this.loadArticle, type: 'button', className: 'btn btn-pink-gradient' },
	                'Get 3 months free'
	              )
	            )
	          )
	        )
	      )
	    );
	  };
	
	  return PricingPage;
	}(_react2.default.Component);
	
	exports.default = PricingPage;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-pricing-index-js-c37a8cb763128fc4c381.js